export function AsyncCallback(
  delay: number = 0,
  callback?: () => void
): MethodDecorator {
  return (target, propertyKey, descriptor: PropertyDescriptor): PropertyDescriptor => {
    const originalMethod = descriptor.value;

    descriptor.value = function(...args: any[])  {
      setTimeout((): void => {
        originalMethod.apply(this, args);
        if (callback) {
          callback();
        }
      }, delay);
    };

    return descriptor;
  };
}
